// src/private/src/pages/app/clients/components/MiniSparkline.jsx
import React, { memo } from 'react';
import { Box } from '@mui/material';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

/**
 * Tiny inline sparkline (no axes, no labels) for embedding in table cells.
 *
 * @param {Array} data - Array of objects, each with a `value` key
 * @param {string} color - Stroke color
 * @param {number} width - Width in px (default 60)
 * @param {number} height - Height in px (default 20)
 */
function MiniSparkline({ data = [], color = '#2196f3', width = 60, height = 20 }) {
  if (!data || data.length < 2) return null;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        ml: 0.75,
      }}
    >
      <ResponsiveContainer width={width} height={height}>
        <LineChart data={data}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default memo(MiniSparkline);
